<template>
  <internal-process
    class="not-found-container"
    @go-back="backHandler"
    :process-name="processTitle"
    :with-main-background="withMainBackground"
    :with-footer-background="withFooterBackground"
  >
    <div class="not-found-page__main-section">
      <img alt="Page not found" src="img/404-face.svg" />
      <h1>It looks like the page or file you’re trying to view doesn’t exist</h1>
      <p>Check the URL, or use the site navigation to find it</p>
      <nav class="not-found-page__links">
        <router-link :to="{ name: 'grid' }">Grid View</router-link>
        <router-link :to="{ name: 'pending' }">Pending View</router-link>
        <router-link :to="{ name: 'login' }">Login</router-link>
      </nav>
    </div>
    <modal />
  </internal-process>
</template>

<script>
import Modal from '@/components/atoms/Modal';
import AccessMixin from '@/mixins/AccessMixin';

export default {
  name: 'not-found',
  components: {
    Modal,
  },
  mixins: [
    AccessMixin,
  ],
  data() {
    return {
      processTitle: 'Route not found',
      withMainBackground: true,
      withFooterBackground: true,
    };
  },
  methods: {
    backHandler() {
      return this.defaultBackAction();
    },
    defaultBackAction() {
      return this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.not-found-container {
  .not-found-page{
    &__main-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: $fc-space-internal-process-main-margin;
    }

    &__links {
      margin-top: $mds-space-3-x;
      width: 50%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        @include mds-link();
      }
    }
  }
}
</style>>
